import type React from 'react'

export const SignInButton = ({
  children,
  ...rest
}: React.ButtonHTMLAttributes<HTMLButtonElement>) => (
  <button
    type="button"
    className="pan-title5 flex place-content-center items-center gap-2 rounded-lg border-2 border-none border-gray-300 bg-transparent px-4 py-2 text-white hover:border-green-300 hover:bg-gray-200 hover:text-gray-900 active:border-green-300 active:bg-green-50 active:text-black disabled:cursor-not-allowed disabled:border-gray-600 disabled:!text-gray-600 disabled:hover:bg-transparent"
    {...rest}
  >
    {children}
  </button>
)
